import { render, staticRenderFns } from "./subscription.vue?vue&type=template&id=4ec0bd3e&scoped=true"
import script from "./subscription.vue?vue&type=script&lang=js"
export * from "./subscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec0bd3e",
  null
  
)

export default component.exports